import styled from 'styled-components'

const Content = styled.div`
  min-height: 96vh;
`

export { Content }
